export const CAUSES_CHILD_INCIDENCES_LIST_KEY = 'CAUSES_CHILD_INCIDENCES_LIST_KEY';
export const CAUSES_INCIDENCES_LIST_KEY = 'CAUSES_INCIDENCES_LIST';
export const CAUSES_INCIDENCES_ONE_KEY = 'CAUSES_INCIDENCES_ONE_KEY';
export const CAUSES_INCIDENCES_CHILDREN_KEY = 'CAUSES_INCIDENCES_CHILDREN_KEY';
